const Spaces = {
  BACKLOT: 'backlot',
  STORAGE: 'storage',
  STUDIO: 'studio',
  FURNITURES: 'furnitures-accessorie',
  ACCESS_ACCOMMODATIONS: 'access-accommodations',
  INFO: 'info',
};

export default Spaces;
